import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Typography } from '@mui/material';
import { FaHeadset, FaTools, FaLifeRing } from 'react-icons/fa';
import UnderConstruction from '../../../components/UnderConstruction';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { useAuthStore } from '../../../auth/state';
import './support_dashboard.css';

// # Helper function to get display name - moved outside component
const getDisplayName = (userProfile, user) => {
  let name = '';
  let username = '';

  // Get name
  if (userProfile?.lastName) {
    name = `${userProfile.lastName}`;
  } else if (userProfile?.firstName) {
    name = `${userProfile.firstName}`;
  } else {
    name = `${user?.email?.split('@')[0] || 'Support'}`;
  }

  // Get username
  if (userProfile?.username) {
    username = `@${userProfile.username}`;
  }

  return { name, username };
};

// # Helper function to get profile photo URL - moved outside component
const getProfilePhotoUrl = (userProfile) => {
  try {
    if (!userProfile?.photoURL) return '/icons/pfp.png';
    if (userProfile.photoURL === '') return '/icons/pfp.png';
    
    // Check if it's a full URL (from Storage)
    if (userProfile.photoURL.startsWith('http')) {
      return userProfile.photoURL;
    }
    
    // If it's just a filename, assume it's the default
    return '/icons/pfp.png';
  } catch (error) {
    console.error('Error getting profile photo:', error);
    return '/icons/pfp.png';
  }
};

// # Support Dashboard component
const SupportDashboard = () => {
  const navigate = useNavigate();
  const { user, userProfile } = useAuthStore();

  // # Memoize display name to prevent unnecessary recalculations
  const displayName = React.useMemo(() => 
    getDisplayName(userProfile, user), [userProfile, user]);

  return (
    <div className="spprt_dsh_container">
      {/* # Use shared header component */}
      <DashboardHeader />

      {/* # Cover Image */}
      <div className="spprt_dsh_cover-section">
        <img 
          src="/icons/cover_ocean.jpg" 
          alt="Cover" 
          className="spprt_dsh_cover-image"
        />
        
        {/* # Title Logo */}
        <div className="spprt_dsh_title-logo">
          <FaLifeRing />
          <h1>Support Portal</h1>
        </div>
      </div>

      {/* # Profile Section */}
      <div className="spprt_dsh_profile-section">
        <div 
          className="spprt_dsh_profile-image-container"
          onClick={() => navigate('/support-dashboard/profile')}
        >
          <img 
            src={getProfilePhotoUrl(userProfile)}
            alt="Profile" 
            className="spprt_dsh_profile-image"
          />
        </div>
        <div className="spprt_dsh_profile-info">
          <h2 className="spprt_dsh_profile-name">
            {displayName.name}
          </h2>
          <div className="spprt_dsh_user_username">
            {displayName.username}
          </div>
        </div>
      </div>
      
      <div className="spprt_dsh_content">
        <Paper className="spprt_dsh_paper">
          <Typography variant="h5" className="spprt_dsh_title">
            <FaHeadset size={24} /> Support Dashboard
          </Typography>
          
          {/* # Use the UnderConstruction component */}
          <UnderConstruction pageName="Support Dashboard" />
        </Paper>
      </div>
      
      <DashboardFooter />
    </div>
  );
};

export default SupportDashboard; 